// TODO: Need to make this environmental
import { BillingPlanDetailCode } from 'shared_server_client/types/billing_plan'
import { Post } from '../components/content-pool/edit-article/types'
import { Dataset } from 'generic/dataset'

declare const RASA_IMAGE_API_ENDPOINT: string
declare const RASA_ASSETS_CDN: string

export interface HasHostedImageURL {
  hosted_image_url?: string,
}

export const sizedArticleUrl = (post: Post, height: number, width: number = null, crop = true): string => {
  return sizedUrl(post.hosted_image_url, height, width, crop)
}

export const sizedUrl = (
  url: string, height: number, width: number = null, crop = true , resize = true): string => {
  const u: string = url
  if (u && isHostedImage(u) ) {
    const params = []
    if (resize) {
      params.push(`h=${height}`)
      if (width) {
        params.push(`w=${width}`)
      }
      if (crop) {
        params.push('fit=crop')
        params.push('crop=entropy')
      }
    }
    let resultUrl = u
    if (params.length) {
      if (resultUrl.indexOf('?') > -1) {
        resultUrl += `&${params.join('&')}`
      } else {
        resultUrl += `?${params.join('&')}`
      }
    }
    return resultUrl
  } else {
    return u
  }
}

// I wonder why this only includes hosted-images-newsbrief?
export const isHostedImage = (url: string): boolean => {
  return (url || '').includes('.s3.amazonaws.com/') || (url || '').includes(RASA_IMAGE_API_ENDPOINT)
}

// Easier to use than URLSearchParams
// https://stackoverflow.com/questions/8648892/convert-url-parameters-to-a-javascript-object
export const queryStringAsParams = (queryString: string): any => {
  try {
    const s = '{"' + decodeURI(queryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}'

    return JSON.parse(s)
  } catch (e) {
    return {}
  }
}

export const parseHref = (href: string) => {
  href = href || ''
  const parts = href ? href.split('?') : []
  const params = parts.length <= 1 ? {} :
    parts[1].split('#').length > 1 ? parts[1].split('#')[0] : queryStringAsParams(parts[1])
  const hash = href.split('#').length > 1 ? href.split('#')[1] : ''
  const route = parts[0].split('#')[0]
  return {
    hash,
    params,
    route,
  }
}

export const canAccessSegment = (avlFeatures, communityId): Promise<boolean> => {
  if (avlFeatures.indexOf(BillingPlanDetailCode.SEGMENT_CODE) === -1) {
    return Promise.resolve(false)
  } else {
    return new Dataset().loadCommunityDataset(
      'communityPartnerSegmentCode',
      communityId
    ).then((cp) => {
      return cp.length > 0 && cp[0].length > 0
    })
  }
}

export const loadPartnerConfiguration = (): Promise<any> => {
  return fetch(`${RASA_ASSETS_CDN}/partner-configuration.json`)
    .then((response) => response.json())
    .then((data) => {
      const hostName = window.location.hostname
      let config = data[hostName]

      if (!config) {
        const parts = hostName.split('.')
        const parentDomain = parts.slice(-2).join('.')
        config = data[parentDomain] || {}
      }

      return config
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to load partner configuration:', error)
      return {}
    })
}

export const applyPartnerConfig = (payload): void => {
  updatePartnerFavicon(payload.FAVICON_URL)
  updatePartnerTitle(payload.TITLE)
}

const updatePartnerFavicon = (faviconUrl: string): void => {
  if (!faviconUrl) return

  const existingIcons = document.querySelectorAll('link[rel*="icon"]')
  existingIcons.forEach(icon => icon.remove())

  // match this with index.html
  const sizes = [
    { size: '32x32', rel: 'icon' },
    { size: '192x192', rel: 'icon' },
    { size: '180x180', rel: 'apple-touch-icon' }
  ]

  sizes.forEach(({ size, rel }) => {
    const link = document.createElement('link')
    link.rel = rel
    link.href = faviconUrl
    link.setAttribute('sizes', size)
    document.head.appendChild(link)
  })

  const msLink = document.querySelector('meta[name="msapplication-TileImage"]')
  if (msLink) {
    msLink.setAttribute('content', faviconUrl)
  } else {
    const meta = document.createElement('meta')
    meta.name = 'msapplication-TileImage'
    meta.content = faviconUrl
    document.head.appendChild(meta)
  }
}

const updatePartnerTitle = (title: string): void => {
  if (!title) return
  document.title = title
}